<template>
  <b-modal
    ref="responsibleModal"
    :title="$t('grossing.modal.changeResponsible')"
    centered
    modal-class="responsible-modal"
  >
    <b-row>
      <b-col>
        <!--Sample Card-->
        <div class="mx-3">
          <b-row
            style="width:100%"
            class="m-0"
          >
            <b-col
              v-if="message"
              cols="12"
              class="d-flex align-items-center justify-content-center px-0"
            >
              <b-card
                style="width:100%"
                class="responsible-card p-2 mb-3"
              >
                <b-row>
                  <b-col
                    cols="auto"
                    class="d-flex justify-content-center align-items-center"
                  >
                    <i
                      class="main fal fa-user-friends"
                      aria-hidden="true"
                    />
                  </b-col>
                  <b-col class="text-left">
                    <span>
                      {{ $t('grossing.modal.responsibleMessage') }}
                    </span>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              class="pl-0 pr-0"
            >
              <div class="form-label">
                <label>{{ routeIsGrossing ? $tc('grossing.modal.grossingResponsible', 1) : $t('laboratory.form.processResponsable') }}</label>
              </div>
              <vt-combo-select
                v-model="grossingResponsibleSelected"
                track-by="id"
                value-key="id"
                label="fullName"
                qa="grossing-responsible-modal-grossing-responsible-div"
                :option-loader="getGrossingReponsible"
              />
            </b-col>
            <b-col
              cols="12"
              class="pl-0 pr-0 mt-3"
            >
              <div class="form-label">
                <label>{{ routeIsGrossing ? $t('grossing.modal.grossingController') : $t('laboratory.form.processTechnician') }}</label>
              </div>
              <vt-combo-select
                v-model="grossingControllerSelected"
                track-by="id"
                value-key="id"
                label="fullName"
                qa="grossing-responsible-modal-grossing-controller-div"
                :option-loader="getGrossingControllers"
              />
            </b-col>
            <b-col
              cols="12"
              class="pl-0 pr-0 mt-3"
            >
              <div class="form-label">
                <label>{{ routeIsGrossing ? $t('grossing.modal.grossingTutor') : $t('laboratory.form.processTutor') }}</label>
              </div>
              <vt-combo-select
                v-model="grossingTutorSelected"
                track-by="id"
                value-key="id"
                label="fullName"
                qa="grossing-responsible-modal-grossing-tutor-div"
                :option-loader="getGrossingTutors"
              />
            </b-col>
            <b-col
              cols="12"
              class="pl-0 pr-0 mt-3 mb-2"
            >
              <div class="form-label">
                <label>{{ routeIsGrossing ? $t('grossing.modal.grossingCoordinator') : $t('laboratory.form.processCoordinator') }}</label>
              </div>
              <vt-combo-select
                v-model="grossingCoordinatorSelected"
                track-by="id"
                value-key="id"
                label="fullName"
                qa="grossing-responsible-modal-grossing-coordinator-div"
                :option-loader="getGrossingCoordinators"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            qa="grossing-responsible-modal-cancel-button"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            :disabled="!grossingControllerSelected && !grossingTutorSelected && !grossingCoordinatorSelected && !grossingResponsibleSelected"
            class="btn--primary btn-sm"
            qa="grossing-responsible-modal-apply-button"
            :params="{ promise: applyChanges }"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { personnelService } from '@/api/resources/personnelService'
import sampleProcessingSampleService from '@/modules/sampleProcessingModule/services/sampleProcessingSampleService'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'

export default {
    name: 'GrossingResponsibleModal',
    props: {
        message: { type: Boolean },
        routeIsGrossing: { type: Boolean }
    },
    data() {
        return {
            grossingControllerSelected: null,
            grossingTutorSelected: null,
            grossingCoordinatorSelected: null,
            grossingResponsibleSelected: null,
            sampleGridSelectedRows: []
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        setResponsiblesForSingleSample(sample) {
            this.grossingControllerSelected = sample.grossingTechController
            this.grossingTutorSelected = sample.grossingTutor
            this.grossingCoordinatorSelected = sample.grossingCoordinator
            this.grossingResponsibleSelected = sample.grossingResponsible
        },
        async applyChanges() {
            const saveData = this.sampleGridSelectedRows.map((sample) => {
                return {
                    caseId: sample.caseStudy.casId,
                    sampleId: sample.samId,
                    grossingTechControllerId: this.grossingControllerSelected ? this.grossingControllerSelected.id : sample.grossingTechController && sample.grossingTechController.id,
                    grossingTutorId: this.grossingTutorSelected ? this.grossingTutorSelected.id : sample.grossingTutor && sample.grossingTutor.id,
                    grossingCoordinatorId: this.grossingCoordinatorSelected ? this.grossingCoordinatorSelected.id : sample.grossingCoordinator && sample.grossingCoordinator.id,
                    grossingResponsibleId: this.grossingResponsibleSelected ? this.grossingResponsibleSelected.id : sample.grossingResponsible && sample.grossingResponsible.id,
                    originalConcurrencyUpdatedAt: sample.originalConcurrencyUpdatedAt
                }
            })
            const [err, response] = await this.toCall(sampleProcessingSampleService.updateBatch(this.labId, saveData))

            if (err) {
                this.showErrorModalGlobal()
                return
            }
            if (response.data.length) {
                const errorSampleLabels = response.data.map(error => this.sampleGridSelectedRows.find(sample => sample.samId === error.id).samLabel)
                this.showErrorModalGlobal(this.$t('grossing.modal.responsiblesSaveUnsuccessful') + ':<br/><ul></ul><li>' + errorSampleLabels.join('</li><li>') + '</li></ul>')
            } else {
                this.showToastSuccessGlobal(this.$t('grossing.modal.responsiblesSaveSuccessful'))
            }
            this.$emit('reloadGrid')
            this.hide()
        },
        show(selectedSamples) {
            this.clearForm()
            this.sampleGridSelectedRows = selectedSamples
            if (this.sampleGridSelectedRows.length === 1) {
                this.setResponsiblesForSingleSample(this.sampleGridSelectedRows[0])
            }
            this.$refs.responsibleModal.show()
        },
        clearForm() {
            this.grossingControllerSelected = null
            this.grossingTutorSelected = null
            this.grossingCoordinatorSelected = null
            this.grossingResponsibleSelected = null
        },
        hide() {
            this.$refs.responsibleModal.hide()
        },
        getGrossingControllers() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.labId, this.routeIsGrossing ? CommonResponsibilityCodeEnum.GROSSING_CONTROLLER : CommonResponsibilityCodeEnum.PROCESSING_CONTROLLER)
        },
        getGrossingTutors() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.labId, this.routeIsGrossing ? CommonResponsibilityCodeEnum.GROSSING_TUTOR : CommonResponsibilityCodeEnum.PROCESSING_TUTOR)
        },
        getGrossingCoordinators() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.labId, this.routeIsGrossing ? CommonResponsibilityCodeEnum.GROSSING_COORDINATOR : CommonResponsibilityCodeEnum.PROCESSING_COORDINATOR)
        },
        getGrossingReponsible() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.labId, this.routeIsGrossing ? CommonResponsibilityCodeEnum.GROSSING_RESPONSIBLE : CommonResponsibilityCodeEnum.PROCESSING_RESPONSIBLE)
        }
    }
}
</script>

<style lang="scss">
  .responsible-modal .modal-dialog {
      @include mq(desktop-wide, max) {
          width: 30%;
      }
      @include mq(desktop-wide, min) {
          width: 30%;
      }
      @include mq(tablet-wide, max) {
          width: 40%;
      }
  }
</style>

<style lang="scss" scoped>
  .responsible-card span{
    font-size: font-size(small);
  }

  .responsible-card i{
    font-size: 25px;
  }

  .responsible-card{
    text-align: justify;
    line-height: 16px;
  }

</style>
